import React, { useEffect, useRef, useState } from "react";
import * as api from "../../common/manipurCommon/API";
import Utils from "../../common/manipurCommon/Utils";
import Swal from "sweetalert2";
import * as func from "../../common/manipurCommon/FunctionCalls";
import Select from "react-select";

interface CopingSkillsInventoryWizardProps {
    data?: any;
}

const CopingSkillsInventoryWizard: React.FC<CopingSkillsInventoryWizardProps> = ({ data }) => {

    const [currentStep, setCurrentStep] = useState(0);
    const [answers, setAnswers] = useState<any>({});
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [athleteId, setAthleteId] = useState("");
    const [assessmentDate, setAssessmentDate] = useState("");
    const [showQuests, setShowQuests] = useState(false);

    const formRef = useRef(null);

    const answerSets = data.answer_sets;
    const questionSets = data.question_sets;

    const currentQuestions = questionSets[currentStep].questions;

    useEffect(() => {
        async function fetchAthlete() {
            const response = await func.listActiveAthletes();
            setAthleteList(Array.isArray(response) ? response : [])
        }
        fetchAthlete();
    }, []);

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    const handleAnswerChange = (questionId: string, answerId: string) => {
        setAnswers((prev: any) => ({
            ...prev,
            [questionId]: answerId,
        }));
    };

    function handleNextStep(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (currentStep < questionSets.length - 1) {
                setCurrentStep((prev) => prev + 1);
            }
        }
    }

    const handleSubmit = () => {
        const formatted = Object.keys(answers).map((questionId) => ({
            questionId,
            answerId: answers[questionId],
        }));

        console.log("Final Payload:", JSON.stringify(formatted));

        // call API

        const formData = new FormData();
        formData.append("athleteId", athleteId);
        formData.append("dateOfAnswered", assessmentDate);
        formData.append("answeredJson", JSON.stringify(formatted));

        fetch(api.SavePsychologyAcsiAssessment, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + Utils.getAccessToken(),
            },
            body: formData,
        })
            .then((res) => res.json())
            .then((result) => {
                if (!result.error) {
                    Swal.fire({
                        title: "Success",
                        text: result.message,
                        icon: "success",
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code === 401) Utils.logoutUser();
                }
            })
            .catch((err) => console.error(err));
    };

    return (
        <div className="card p-3">

            <div className="row">
                <div className="col-lg-6 mb-10">
                    <div className="input-space">
                        <label className="form-label">Athlete</label>
                        <Select
                            name="athleteId"
                            value={athleteList.find(athlt => athlt.userId === athleteId) ? {
                                value: athleteId,
                                label: athleteList.find(athlt => athlt.userId === athleteId).athleteName
                            } : null}
                            onChange={(e) => setAthleteId(e.value)}
                            styles={customSelect}
                            required
                            placeholder="Select Athlete"
                            options={athleteList.map(athlt => ({
                                value: athlt.userId,
                                label: athlt.athleteName
                            }))}>
                        </Select>
                    </div>
                </div>
                <div className="col-lg-6 mb-10">
                    <div className="input-space">
                        <label className="form-label">Date Of Assessment</label>
                        <input
                            type="date"
                            className="form-control"
                            required
                            name="assessment_date"
                            value={assessmentDate}
                            onChange={(e) => { setAssessmentDate(e.target.value); setShowQuests(true) }}
                            placeholder="Enter Date of Assessment" />
                    </div>
                </div>
            </div>

            {showQuests && (
                <>
                    <h3>{questionSets[currentStep].set_name}</h3>

                    <form ref={formRef}>
                        {currentQuestions.map((q: any) => (
                            <div key={q.questionId} className="mb-3" style={{opacity: answers[q.questionId] ? 0.5 : 1,transition: "0.3s"}}>
                                <h6 style={{color:"#1eb0d5"}}>{q.question_text}</h6>

                                <div className="d-flex flex-wrap gap-4">
                                    {answerSets.map((ans: any) => (
                                        <label key={ans.answerId} className="d-flex align-items-center gap-1" style={{maxHeight:"30px"}}>
                                            <input
                                                type="radio"
                                                name={`question-${q.questionId}`}
                                                required
                                                value={ans.answerId}
                                                checked={answers[q.questionId] === ans.answerId}
                                                onChange={() =>
                                                    handleAnswerChange(q.questionId, ans.answerId)
                                                }
                                            />
                                            {ans.name}
                                        </label>
                                    ))}
                                </div>
                            </div>
                        ))
                        }

                        <div className="d-flex justify-content-end mt-4">
                            {/* {currentStep > 0 && (
                    <button onClick={() => setCurrentStep((prev) => prev - 1)}>
                        Previous
                    </button>
                )} */}

                            {currentStep < questionSets.length - 1 ? (
                                <button type="button" className="btn btn-primary me-2" onClick={handleNextStep}>
                                    Next
                                </button>
                            ) : (
                                <button type="button" className="btn btn-secondary" onClick={handleSubmit}>Submit</button>
                            )}
                        </div>
                    </form >
                </>
            )}
        </div >
    )
};

export default CopingSkillsInventoryWizard;